define([
    "components/contact-form",
    "pages/home/_faq-home",
    "utils/analytics"
    ], function(ContactForm, FAQHome, Analytics) {
        "use strict";

        return App.View.extend({
            el: "body",

            events: {
                "click .js-home__contact__button" : "goToContactForm",
                "click .js-show-contact" : "showContactForm",
                "click .js-show-modal-devices" : "showDevices"
            },

            initialize: function() {
                this.contactForm = new ContactForm({
                    landing: 'community'
                });
                this.contactForm.model.set({
                    company : "Comunidad de Vecinos",
                    site    : "Parkingdoor para Comunidades"
                });
                this.listenTo(this.contactForm, "contact-form:sent-ok", this.onContactFormSent);

                new FAQHome();
            },

            onContactFormSent: function() {
                Analytics.trackSendContactForm(window.location.pathname);
            },

            showContactForm: function(e) {
                App.Modal.closeModal();
                this.goToContactForm(e);
            },

            goToContactForm: function(e) {
                e.preventDefault();

                $("html, body").animate({
                    scrollTop : $('.home__contact-section').offset().top - 20
                }, 1000);
            },

            showDevices: function(e) {
                App.Modal.showModal(e, {
                    modalElement : $(".js-devices"),
                    modalView    : this
                });
            }
        });
    });
